// A wrapper for <Route> that redirects to the login

import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import LoadingPage from 'src/components/pages/LoadingPage'
import { SynPerfis } from 'src/core/consts/synPerfis'
import { SynRoutes } from 'src/core/consts/synRoutes'
import useAuth from 'src/hooks/useAuth'

interface PrivateRouteProps extends RouteProps {}

const rotasIsentasBloqueioBacen = new Set([
  SynRoutes.regularizacaoBacen,
  SynRoutes.selecionarPerfil,
  SynRoutes.selecionarSetorParceiro,
  SynRoutes.termosDeUso,
  SynRoutes.politicaDePrivacidade,
  SynRoutes.definirSenha,
  SynRoutes.alterarSenha
])

function rotaIsentaBloqueioBacen(pathname?: string) {
  if (!pathname) return false
  if (rotasIsentasBloqueioBacen.has(pathname)) return true
  if (pathname.startsWith('/operacional-regularizacao-bacen/')) return true
  return false
}

// screen if you're not yet authenticated.
export default function PrivateRoute({ children, ...rest }: PrivateRouteProps) {
  const {
    signed,
    loading,
    user,
    perfilAtual,
    pendenciaBacen,
    carregandoPendenciaBacen
  } = useAuth()

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (signed && user.primeiroAcesso) {
          return (
            <Redirect
              to={{
                pathname: SynRoutes.definirSenha,
                state: { from: location }
              }}
            />
          )
        }

        if (signed && !user.aceitouTermo) {
          return (
            <Redirect
              to={{
                pathname: SynRoutes.termosDeUso,
                state: { from: location }
              }}
            />
          )
        }

        if (signed && !perfilAtual) {
          return (
            <Redirect
              to={{
                pathname: SynRoutes.selecionarPerfil,
                state: { from: location }
              }}
            />
          )
        }

        if (
          signed &&
          perfilAtual === SynPerfis.PARCEIRO &&
          user.lstSetorFuncionario?.length > 1 &&
          !user.setorFuncionario &&
          user.aceitouTermo
        ) {
          return (
            <Redirect
              to={{
                pathname: SynRoutes.selecionarSetorParceiro,
                state: { from: location }
              }}
            />
          )
        }

        const bloqueioBacenConhecido =
          !carregandoPendenciaBacen &&
          !!pendenciaBacen &&
          pendenciaBacen.bloqueioAtivo === true &&
          pendenciaBacen.temPendencia === true

        if (
          signed &&
          bloqueioBacenConhecido &&
          !rotaIsentaBloqueioBacen(location.pathname)
        ) {
          return (
            <Redirect
              to={{
                pathname: SynRoutes.regularizacaoBacen,
                state: { from: location }
              }}
            />
          )
        }

        return (
          <>
            {signed && !loading ? (
              children
            ) : loading ? (
              <LoadingPage />
            ) : (
              <Redirect
                to={{
                  pathname: SynRoutes.signin,
                  state: { from: location }
                }}
              />
            )}
          </>
        )
      }}
    />
  )
}
